export const generateValidationMessage = (record, status, fieldName) => {
  if (!record || !fieldName) {
    return "This field value is already in use.";
  }

  const fieldDisplayNames = {
    email: "email",
    nationalId: "National ID",
    iqamaNo: "Iqama number",
    phone: "phone number",
    ibanNo: "IBAN number",
    drivinngLicenseNo: "Driving license number",
    gosiRegNo: "GOSI  number",
    mudadRegNo: "Mudad number",
    passportNo: "Passport number",
    insuranceNo: "Insurance number",
    visaNo: "Visa number",
    contractNo: "Contract number",
    healthCardNo: "Health card number",
  };

  const displayName = fieldDisplayNames[fieldName] || fieldName;
  const safeStatus = status || "unknown";

  const statusMessages = {
    active: `This ${displayName} is already registered and active.`,
    inactive: `This ${displayName} is registered but inactive.`,
    draft: `This ${displayName} is linked to a draft record.`,
    unknown: `This ${displayName} is already in use.`,
  };

  return statusMessages[safeStatus] || `This ${displayName} is already in use.`;
};
